
import Vue from 'vue';

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export default Vue.extend({
  name: 'NumberField',
  props: {
    value: {
      type: [Number, String],
      default: null
    },
    warning: {
      type: Boolean,
      default: false
    },
    warningText: {
      type: String,
      default: null
    }
  },
  computed: {
    _attrs (): any {
      return this.$attrs;
    },
    _listeners (): any {
      const listeners = Object.assign({}, this.$listeners);
      delete listeners.input;
      return listeners;
    },
    hasErrors (): boolean {
      return this._attrs.rules && this._attrs.rules.length > 0;
    }
  },
  data: () => ({
    inner_value: null,
    preventNextNullValue: false
  }),
  watch: {
    value () {
      // eslint-disable-next-line eqeqeq
      if (this.parseNumber(this.inner_value) != this.parseNumber(this.value)) {
        // if value realy update
        this.setInnerValue(this.value);
      }
    },
    inner_value (oldValue, newvalue) {
      // clean value
      this.setInnerValue(this.inner_value);
      // eslint-disable-next-line eqeqeq
      if (this.parseNumber(oldValue) != this.parseNumber(newvalue)) {
        // if value realy update
        this.updateValue();
      }
    }
  },
  created () {
    this.setInnerValue(this.value);
  },
  methods: {
    numberToString (value: number | string): string {
      // tostring
      const str = value === null || value === undefined ? '' : (typeof value === 'number' ? value.toString() : value);
      // clean string
      return str.replace(/[^0-9,.+-]/g, '').replace(',', '.');
    },
    parseNumber (str: number | string): number {
      if (str === null || str === undefined || str === '') {
        return null;
      }
      const val = parseFloat(this.numberToString(str));
      return isNaN(val) ? null : val;
    },

    setInnerValue (value: number | string) {
      // to string
      const str = this.numberToString(value);
      // is valid
      const _value = this.parseNumber(str);

      if (_value !== null) {
        this.inner_value = str;
      } else {
        this.inner_value = '';
      }

      if (this.inner_value !== value) {
        setTimeout(() => { this.$forceUpdate(); }, 200);
      }
    },
    updateValue () {
      const value = this.parseNumber(this.inner_value);
      if (value === null && this.preventNextNullValue) {
        this.preventNextNullValue = false;
        return;
      }
      this.$emit('input', value);
    },

    onKeyInput (event: KeyboardEvent) {
      if (event.key.length === 1 && /^[^0-9+,.-]$/.test(event.key)) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (event.key === '.') {
        // trick for prevent "[0-9]+\." inputs to return null (browser limitation)
        this.preventNextNullValue = true;
      } else {
        this.preventNextNullValue = false;
      }
    },

    focus () {
      (this.$refs.field as any).focus();
    },
    blur () {
      (this.$refs.field as any).blur();
    }
  }
});
